import { Component, OnInit } from '@angular/core';
import { HttpErrorResponse } from '@angular/common/http';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { Location } from '@angular/common';
import { faCircleArrowLeft, faHomeAlt } from '@fortawesome/free-solid-svg-icons';
import { LawService } from '../_services';
import { PremiseService } from '../_services/premise.service';
import { PremiseAssociation } from '../_models/premise_association';
import { forkJoin } from 'rxjs';

interface Law {
  id?: number;
  title: string;
  description: string;
  propertyId: number;
}

@Component({
    selector: 'app-laws',
    templateUrl: './laws.component.html',
    styleUrls: ['./laws.component.css'],
    standalone: false
})
export class LawsComponent implements OnInit {

  loading = false;
  searchLaw = '';

  laws: Law[] = [];
  associatedPropertyIds: number[] = [];

  faCircleArrowLeft = faCircleArrowLeft;
  faHomeAlt = faHomeAlt;

  constructor(
    private toastr: ToastrService,
    private lawService: LawService,
    private premiseService: PremiseService,
    private _location: Location,
    private router: Router
  ) {}

  ngOnInit(): void {
    this.loadLawsForAssociatedProperties();
  }

  goBack() {
    this._location.back();
  }

  goHome(): void {
    this.router.navigate(['/home']);
  }

  private loadLawsForAssociatedProperties(): void {
    this.loading = true;
    this.premiseService.fetchUserAssociation().subscribe({
      next: (associations: PremiseAssociation[]) => {
        const propertyIds = [...new Set((associations || []).map((item) => item.propertyId).filter((id) => !!id))];
        this.associatedPropertyIds = propertyIds;

        if (propertyIds.length === 0) {
          this.loading = false;
          this.laws = [];
          this.toastr.info('No property associations were found for your account.', 'Info');
          return;
        }

        const lawRequests = propertyIds.map((propertyId) => this.lawService.getLawsByPropertyId(propertyId));
        forkJoin(lawRequests).subscribe({
          next: (lawGroups: Law[][]) => {
            this.laws = lawGroups.flat();
            this.loading = false;
          },
          error: (error: HttpErrorResponse) => {
            this.loading = false;
            this.toastr.error('Failed to retrieve laws.', 'Error');
            if (error) {
              console.log('Law fetch error:', error);
            }
          }
        });
      },
      error: (error: HttpErrorResponse) => {
        this.loading = false;
        this.toastr.error('Failed to fetch associated properties.', 'Error');
        if (error) {
          console.log('Association fetch error:', error);
        }
      }
    });
  }

}
